import { Record } from 'immutable';

export default class RecruitmentAdApplicationRecord extends Record({
  id: undefined,
  createdAt: undefined,
  resource: undefined,
}) {
}
